import { apiHelper } from "./api_helper";

export const uploadApi = {
    UploadImg: (data) => apiHelper.post("upload/image", data),
    ReadUploadedExcelFile: (data) => apiHelper.post('read/excel', data)
}